/**
 * The offline server's numbers. The game's paytable, its scatter thresholds and its multiplier distribution are not
 * settled yet (the `merge` mechanic's rules, "Numbers still to settle"): these PLACEHOLDERS only make the fixture rounds
 * pay something plausible. Nothing a player reads states them — the rules page names no number the backend has not
 * fixed.
 */

/** A cluster's pay in hundredths of the bet, by symbol and size (4, 5, 6, 7, 8 or more cells). */
const PLACEHOLDER_PAYTABLE: Readonly<Record<string, readonly number[]>> = {
  L1: [20, 30, 40, 50, 60],
  L2: [30, 40, 50, 70, 90],
  L3: [40, 50, 70, 90, 120],
  L4: [50, 70, 90, 120, 150],
  H1: [80, 100, 130, 170, 220],
  H2: [100, 130, 170, 220, 300],
  H3: [150, 200, 250, 330, 450],
  H4: [200, 260, 340, 450, 600],
};

export function placeholderPayHundredths(symbolId: string, size: number): number {
  const row = PLACEHOLDER_PAYTABLE[symbolId];
  if (!row) throw new Error(`placeholderPayHundredths: "${symbolId}" does not pay`);
  return row[Math.min(size, 8) - 4];
}

/** Scatters on a base spin's last board that trigger free spins (placeholder). */
export const FREE_SPINS_SCATTER_COUNT = 3;

/** The big-win tiers, in bet multiples: the offline boot's settings and the offline server's `present_big_win` alike. */
export const BIG_WIN_TIERS = [
  { levelIdentifier: "nice", minWinMultiplier: 8 },
  { levelIdentifier: "big", minWinMultiplier: 15 },
  { levelIdentifier: "huge", minWinMultiplier: 40 },
  { levelIdentifier: "epic", minWinMultiplier: 100 },
] as const;
